import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Collapse } from 'antd';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import SeoHead from '../../components/common/SeoHead';
import EnquiryForm from '../../components/common/EnquiryForm';
import LoadingScreen from '../../components/common/LoadingScreen';
import api from '../../services/api';
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css';

const UPLOADS_BASE = process.env.REACT_APP_UPLOADS_URL || 'https://www.businessmateworkflow.in';

const BlogDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [seo, setSeo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    api.get(`/blog-detail/${slug}`)
      .then((res) => {
        setBlog(res.data.data);
        setSeo(res.data.seo);
      })
      .catch((err) => {
        if (err.response?.status === 404) setNotFound(true);
      })
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return <LoadingScreen />;
  }

  if (notFound || !blog) {
    return (
      <main>
        <Navbar />
        <div className="container text-center" style={{ padding: '100px 0' }}>
          <h1>Article Not Found</h1>
          <p>This post may have been moved or is no longer available.</p>
          <button className="btn btn-primary" onClick={() => navigate('/blog')}>Back to Blog</button>
        </div>
        <Footer />
      </main>
    );
  }

  return (
    <main>
      <SeoHead seo={seo} />
      <Navbar />

      <section style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', padding: '40px 0', color: '#fff' }}>
        <div className="container">
          <Link to="/blog" style={{ color: '#94a3b8', fontSize: 14, textDecoration: 'none' }}>&larr; Back to Blog</Link>
          <h1 style={{ fontSize: 34, fontWeight: 700, marginTop: 16, maxWidth: 800, color:'#fff' }}>{blog.h1 || blog.title}</h1>
          <div style={{ display: 'flex', gap: 16, marginTop: 16, color: '#94a3b8', fontSize: 14 }}>
            <span><i className="las la-user" /> {blog.author || 'BusinessMate Workflow'}</span>
            <span><i className="las la-calendar" /> {new Date(blog.published_at || blog.created_at).toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
          </div>
        </div>
      </section>

      <section style={{ padding: '50px 0' }}>
        <style>{`
          .blog-detail-row { display: flex; flex-wrap: wrap; margin: 0 -15px; }
          .blog-detail-content, .blog-detail-sidebar { padding: 0 15px; width: 100%; }
          .blog-detail-sidebar { margin-top: 32px; }
          @media (min-width: 992px) {
            .blog-detail-content { flex: 0 0 70%; max-width: 70%; }
            .blog-detail-sidebar { flex: 0 0 30%; max-width: 30%; margin-top: 0; }
          }
        `}</style>
        <div className="container">
          <div className="blog-detail-row">
            <div className="blog-detail-content">
              {blog.image_url && (
                <img
                  src={`${UPLOADS_BASE}/${blog.image_url}`}
                  alt={blog.image_alt_text || blog.title}
                  style={{ width: '100%', borderRadius: 12, marginBottom: 32 }}
                />
              )}

              <div
                style={{ fontSize: 17, lineHeight: 1.9, color: '#334155' }}
                dangerouslySetInnerHTML={{ __html: blog.content || '' }}
              />

              {blog.tags && blog.tags.length > 0 && (
                <div style={{ marginTop: 32, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {blog.tags.map((tag, idx) => (
                    <span key={idx} style={{ background: '#f1f5f9', padding: '4px 12px', borderRadius: 16, fontSize: 13, color: '#475569' }}>
                      #{typeof tag === 'string' ? tag : tag.name}
                    </span>
                  ))}
                </div>
              )}

              {blog.faqs && blog.faqs.length > 0 && (
                <div style={{ marginTop: 48 }}>
                  <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 20 }}>Frequently Asked Questions</h2>
                  <Collapse
                    items={blog.faqs.map((faq, idx) => ({
                      key: idx,
                      label: faq.question,
                      children: <p>{faq.answer}</p>
                    }))}
                  />
                </div>
              )}
            </div>

            <div className="blog-detail-sidebar">
              <div style={{ position: 'sticky', top: 24 }}>
                <EnquiryForm sourceLabel={blog.title} sourceUrl={typeof window !== 'undefined' ? window.location.href : ''} />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default BlogDetail;
